import * as React from "react";
import "../../style/fonts.css";
import "./checkEmails.css";
import CtaButton from "../ctaButton/ctaButton";
import { Link } from "react-router-dom";
import translate from "../../translations/i18n";

class CheckEmailsScr extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="CHECKEMAILS_CONT">
        <div className="CHECKEMAILS_CONT_CENTER">
          <div className="CHECKEMAILS_TITLE">
            <div className="TITLE_2">{translate("CHECK_YOUR_MAIL_TITLE")}</div>
          </div>
          <div className="CHECKEMAILS_TEXT">
            <div className="REG_TEXT">
              {translate("CHECK_YOUR_MAIL_TEXT", {
                entered_email: this.props.location.state.mailAddress
              })}
            </div>
          </div>
          <Link to="/register">
            <div className="CHECKEMAILS_BTN_AREA">
              <CtaButton
                width={"280px"}
                text={translate("CTA_BACK_TO_LOGIN")}
                color={"white"}
              />
            </div>
          </Link>
        </div>
      </div>
    );
  }
}

export default CheckEmailsScr;



// WEBPACK FOOTER //
// ./src/components/Registration/checkEmails.tsx